export default __webpack_public_path__ + "static/media/leader.69acb6d1.svg";